import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ['collapser', 'icon', 'content', 'name']
  static values = { forceExpanded: Boolean }

  connect() {
    // If forceExpanded is set, always expand and ignore local storage
    if (this.forceExpandedValue) {
      this.toggleDetails(true)
      return
    }

    if (!this.hasNameTarget) return

    const stored = window.localStorage.getItem(this.nameTarget.dataset.name)
    // Only apply stored state if user has explicitly toggled before
    // Otherwise, leave the HTML as-is (expanded by default)
    if (stored !== null) {
      this.toggleDetails(stored === "true")
    }
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    // Don't toggle if we're in the middle of a sortable drag
    if (this.element.classList.contains('sortable-chosen') ||
        this.element.classList.contains('sortable-ghost') ||
        document.querySelector('.sortable-chosen, .sortable-ghost')) {
      return
    }

    if (!this.hasContentTarget) { return }
    const expanded = this.contentTarget.classList.contains('d-none')
    if (this.hasNameTarget) {
      window.localStorage.setItem(this.nameTarget.dataset.name, expanded)
    }
    this.toggleDetails(expanded)
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.toggle(event)
    }
  }

  toggleDetails(expanded) {
    if(expanded) {
     if(this.hasContentTarget) { this.contentTarget.classList.remove('d-none') }
     if(this.hasIconTarget) {
       this.iconTarget.classList.remove('fad', 'fa-caret-right')
       this.iconTarget.classList.add('fad', 'fa-caret-down')
     }
    } else {
     if(this.hasContentTarget) { this.contentTarget.classList.add('d-none') }
     if(this.hasIconTarget) {
       this.iconTarget.classList.remove('fad', 'fa-caret-down')
       this.iconTarget.classList.add('fad', 'fa-caret-right')
     }
    }
  }
}
